module.exports = __webpack_public_path__ + "static/img/customer.4b439874.png";